<template>
  <div class="super-admin-header">
<!--    <div class="super-admin-header__logo">-->
<!--      <img :src="require('../../../assets/images/logo.svg')">-->
<!--    </div>-->
    <div class="super-admin-header__info" style="justify-content: flex-end">
      <SelectLang/>
<!--      <div class="super-admin-header__user-info">-->
<!--        <img src="../../../assets/images/user.svg" alt="">-->
<!--        <span>-->
<!--	      <div><slot name="userName"></slot></div>-->
<!--	      <div><slot name="roleName"></slot></div>-->
<!--        </span>-->
<!--        <span class="menu-dropdown">-->
<!--	       <img src="../../../assets/images/icons/chevron-down.svg">-->
<!--           <router-link to="/user-settings" class="drop-down">{{ $t('settings') }}</router-link>-->
<!--        </span>-->
<!--        <span class="divider"/>-->
<!--        <span style="cursor: pointer"><img src="../../../assets/images/icons/ring-bell.svg"></span>-->
<!--        <span style="cursor: pointer" @click="systemLogout"><img src="../../../assets/images/icons/logout.svg"></span>-->
<!--      </div>-->
        <v-menu offset-y open-on-hover>
            <template v-slot:activator="{ on, attrs }">
                <div class="menu-btn" v-bind="attrs" v-on="on">
                    <div style="display: flex; flex-direction: row; flex-wrap: nowrap; gap: 12px; align-items: center; padding: 0 15px">
                        <img src="../../../assets/images/user.png" alt="" width="40px">
                        <div style="display: flex; flex-direction: column; flex-wrap: nowrap">
                            <span style="color: #2F80ED; font-size: 14px"><slot name="userName"></slot></span>
                            <span style="color: #707683; font-size: 12px"><slot name="roleName"></slot></span>
                        </div>
<!--                        <img src="../../../assets/images/icons/chevron-down.svg">-->
                    </div>
                </div>
            </template>

            <v-list>
<!--                <v-list-item style="display: flex; flex-direction: row; padding: 8px">-->
<!--                    <v-btn-toggle v-model="text" v-for="(item, i) in languages" :key="i" tile color="deep-purple" group>-->
<!--                        <v-btn :value="item.code" style="height: 30px;" @click="changeLang(item.code)">{{item.title}}</v-btn>-->
<!--                    </v-btn-toggle>-->
<!--                </v-list-item>-->
<!--                <v-divider/>-->
                <v-list-item class="menu-lst">
                    <v-list-item-title>
                        <router-link to="/user-settings/profile" class="drop-down menu-txt">{{$t('my_profile')}}</router-link>
                    </v-list-item-title>
                </v-list-item>
                <v-list-item class="menu-lst">
                    <v-list-item-title>
                        <router-link to="/user-settings" class="drop-down menu-txt">{{$t('settings')}}</router-link>
                    </v-list-item-title>
                </v-list-item>
                <v-list-item class="menu-lst">
                    <v-list-item-action>
                        <span class="drop-down menu-txt" @click="systemLogout">
                            {{$t('logout')}}
                        </span>
                    </v-list-item-action>
                </v-list-item>
            </v-list>
        </v-menu>
    </div>
  </div>
</template>

<script type="module">
// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import { getMessaging, getToken } from 'firebase/messaging'
import { mapActions } from 'vuex'
import SelectLang from '../../select/SelectLang'
import FirebaseService from '@/_services/firebase.service'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyA6pXgemoCyxNZHSstVs4YXFFGTeEFPaSc',
  authDomain: 'smart-school-b2d08.firebaseapp.com',
  databaseURL: 'https://smart-school-b2d08-default-rtdb.asia-southeast1.firebasedatabase.app',
  projectId: 'smart-school-b2d08',
  storageBucket: 'smart-school-b2d08.appspot.com',
  messagingSenderId: '564443220610',
  appId: '1:564443220610:web:efd5277477d0c29507429b',
  measurementId: 'G-J8BTWXSY57'
}

// Initialize Firebase
// eslint-disable-next-line no-unused-vars
const app = initializeApp(firebaseConfig)

const messaging = getMessaging()
getToken(messaging, { vapidKey: 'BBTUIQfu6SPPGnp8tEbzFvHcqVMcGgw6ST8kek_EE4F1qMO3OxSSP5b9dxhJQcMscT7PPp73qYrN2Vk8LzdC9NU' }).then((currentToken) => {
  if (currentToken) {
    console.log('Token is: ', currentToken)
    FirebaseService.setToken({
      deviceName: 'NAME',
      osType: 'CHROME',
      osVersion: '',
      token: currentToken
    })
  } else {
    console.log('No registration token available. Request permission to generate one.')
  }
}).catch((err) => {
  console.log('An error occurred while retrieving token. ', err)
})
function requestPermission () {
  console.log('Requesting permission...')
  Notification.requestPermission().then((permission) => {
    if (permission === 'granted') {
      console.log('Notification permission granted.')
    }
  })
}
export default {
  name: 'SuperAdminHeader',
  components: { SelectLang },
  methods: {
    ...mapActions('account', ['login', 'logout']),
    systemLogout () {
      this.$router.push('/login')
      this.logout()
      window.location.reload()
    },
    changeLang (lang) {
      window.localStorage.setItem('schoolLang', JSON.stringify(lang))
      this.$router.go(0)
    }
  },
  mounted () {
    requestPermission()
    const selectedLang = JSON.parse(window.localStorage.getItem('schoolLang'))
    this.text = selectedLang || 'kg'
    this.$root.$i18n.locale = this.text
  },
  data: () => ({
    text: 'ru',
    languages: [
      { title: 'РУ', code: 'ru' },
      { title: 'КГ', code: 'kg' }
    ]
  })
}
</script>

<style lang="scss">
.menu-txt{
    text-decoration: none;
    color: black !important;
    font-size: 14px;
    cursor: pointer;
}
.menu-lst:hover{
    background-color: rgba(198, 203, 212, 0.31);
}
.menu-btn{
    padding: 4px 0;
    border-radius: 4px;
    margin-right: 4px;
}
.menu-btn:hover{
    background-color: rgba(198, 203, 212, 0.31);
}
.menu-btn:active{
    background-color: rgba(198, 203, 212, 0.45);
}
  .super-admin-header {
    height: 76px;
    background: #FFFFFF;
    width: 100%;
    display: flex;
    font-family: Helvetica,sans-serif;
    font-style: normal;
    font-weight: normal;

    &__logo {
      background: linear-gradient(180deg, #4A27F3 0%, #34A0FF 100%);
      flex-basis: 96px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    &__info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: calc(100% - 96px);
    }
    &__title {
      color: rgba(29, 25, 76, 0.75);
      font-family: Open Sans,sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 18px;
      line-height: 119%;
      margin-left: 25px;
    }
    &__user-info {
      display: flex;
      align-items: center;
      margin-right: 40px;

      > span {
        display: block;

        &.divider {
          border: 1px solid #EFF4F7;
          transform: rotate(90deg);
          width: 52px;
          height: 0;
        }
      }
      span:nth-child(2) {
        margin: 0 20px;
      }
      span:nth-child(5) {
        margin: 0 20px 0 0;
      }

      > span:first-child {
        div:first-child {
          font-size: 14px;
          line-height: 16px;
          text-align: right;
          letter-spacing: 0.01em;
          color: #000000;
        }
        div:last-child {
          font-size: 12px;
          line-height: 14px;
          text-align: right;
          letter-spacing: 0.01em;
          color: #A6ACBE;
        }
      }
    }
    .select-lang {
        max-width: 55px;
        .v-input__slot:before {
            content: none;
        }
    }
    .menu-dropdown {
        position: relative;
        cursor: pointer;
        .drop-down {
            display: none;
            background: #fff;
            position: absolute;
            top: 24px;
            z-index: 10;
            left: -35px;
            border: 1px solid #A6ACBE;
            border-radius: 5px;
            padding: 10px 5px;
            color: #1976d2;
            cursor: pointer;
            text-decoration: none;
        }
        &:hover {
            .drop-down {
                display: block;
            }
        }
    }
  }

@media (max-width: 420px) {
}
</style>
